import { Block, Spacing, PrimaryButton, SecondaryButton } from 'ia-react-core';
import React, { FC, ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { StyledCheckCircleIcon, StyledDiv, StyledActionBar, StyledT3 } from './ConfirmationPage.styles';
import redirectTo from '../../utils/redirectTo';

export interface ConfirmationPageProps {
  title: string;
  children: ReactNode;
  external?: boolean;
  closeButtonText?: string;
  isCloseButtonSecondary?: boolean;
  redirect?: string;
  onClose?: () => void;
}

const ConfirmationPage: FC<ConfirmationPageProps> = ({
  title,
  children,
  external,
  closeButtonText,
  isCloseButtonSecondary,
  redirect,
  onClose,
}) => {
  const { t } = useTranslation('ConfirmationPage');
  const history = useHistory();
  const handleCloseButton = useCallback(() => {
    if (external) window.location.href = redirect; else redirectTo(redirect, history);
  }, [external, history, redirect]);
  const Button = !isCloseButtonSecondary ? PrimaryButton : SecondaryButton;

  return (
    <>
      <Block white>
        <StyledDiv data-testid="ConfirmationTile">
          <StyledCheckCircleIcon />
          <Spacing m-t={12}>
            <StyledT3>{title}</StyledT3>
            {children}
          </Spacing>
        </StyledDiv>
      </Block>
      <StyledActionBar flexButtons>
        <Button wrapText onClick={onClose || handleCloseButton}>
          {closeButtonText || t('closeButton')}
        </Button>
      </StyledActionBar>
    </>
  );
};

export default ConfirmationPage;
